/* Renders the static maintenance banner in place of the app, keeping the current URL,
** and polls a gated endpoint so the tab recovers on its own when maintenance ends.
**
** Two callers: the APP_INITIALIZER (maintenance was already on when the tab loaded)
** and the HTTP interceptor (maintenance started while the tab was open). A 503 is the
** only signal — the response body is not inspected, because during a deploy the 503
** comes from the IIS rewrite rule, which cannot emit a JSON body. */

let shown = false;

export function showMaintenanceScreen(apiUrl: string): void {
	if (shown) return;
	shown = true;

	const startRecoveryPolling = () => setInterval(() => {
		fetch(apiUrl + '/activity/types', { cache: 'no-store' })
			.then(r => { if (r.status !== 503) window.location.reload(); })
			.catch(() => { /* backend down mid-window; keep waiting */ });
	}, 15000);

	const render = (html: string) => {
		document.open();
		document.write(html);
		document.close();
		startRecoveryPolling();
	};

	/* Under consolidated serving the SPA and maintenance.html share an origin with the
	** API, so during a deploy this fetch hits the same 503 rule as everything else.
	** Rendering that response would blank the page, hence the inline fallback. */
	fetch('/maintenance.html', { cache: 'no-store' })
		.then(r => {
			if (!r.ok) throw new Error(`HTTP ${r.status}`);
			return r.text();
		})
		.then(render)
		.catch(() => render(FALLBACK_BANNER));
}

const FALLBACK_BANNER = `<!DOCTYPE html><html lang="en"><head><meta charset="utf-8">
<title>Project Board &mdash; Maintenance</title></head>
<body style="margin:0;font-family:-apple-system,'Segoe UI',Roboto,Arial,sans-serif;background:#f4f6f8;color:#212529;display:flex;min-height:100vh;align-items:center;justify-content:center">
<div style="background:#fff;border:1px solid #dee2e6;border-radius:8px;max-width:34rem;margin:1rem;padding:2.5rem 3rem;text-align:center">
<h1 style="font-size:1.4rem;margin:0 0 1rem">Project Board is undergoing maintenance</h1>
<p>The site is briefly unavailable. This page reloads by itself when the site is back.</p>
</div></body></html>`;
